<form [formGroup]="form" (ngSubmit)="formService.submit()">

    <div class="page_title">
        <div class="row marges">
            <div class="col y_items_center">
                <h1 class="title">{{ 'society.distributor.update.value' | translate }}</h1>
            </div>

            <div class="col_content y_items_center">

                <!-- Retour -->

                <button class="btn_cta btn_lines btn_little" type="button" (click)="redirectToList()">
                    {{ 'society.distributor.list.back.value' | translate }}
                </button>

                <!-- Soumission -->

                <button class="btn_cta btn_little" type="submit">
                    {{ 'form.submit.action.value'|translate }}
                </button>

            </div>
        </div>
    </div>

    <!-- Gestion des onglets -->

    <mat-tab-group #tabGroup>
        <mat-tab [label]="'society.distributor.generalData.value' | translate">
            <ng-container *ngTemplateOutlet="generalDataTemplate"></ng-container>
        </mat-tab>
        <mat-tab [label]="'society.distributor.accessOffers.value' | translate">
            <ng-container *ngTemplateOutlet="accessOffersTemplate"></ng-container>
        </mat-tab>
        @if(societyDistributor.distributor.commission.enable) {
            <mat-tab [label]="'society.distributor.commission.value' | translate">
                <ng-container *ngTemplateOutlet="commissionTemplate"></ng-container>
            </mat-tab>
        }
    </mat-tab-group>

</form>

<!-- Données générales -->

<ng-template #generalDataTemplate>

    <div class="row marges ligne_form">
        <div class="col_12">
            <div class="text_content">
                <p>
                    <strong>{{ 'distributor.name.value' | translate }}</strong> : {{ societyDistributor.distributor.name }}
                </p>
                <p>
                    <strong>{{ 'form.user.fields.email.contact.value' | translate }}</strong> : {{ societyDistributor.distributor.email }}
                </p>
                <p>
                    <strong>{{ 'form.user.fields.phone.contact.value' | translate }}</strong> : {{ societyDistributor.distributor.phone }}
                </p>
                <p>
                    <strong>{{ 'form.user.fields.immatriculation.value' | translate }}</strong> : {{ societyDistributor.distributor.registration }}
                </p>
                <p>
                    <strong>{{ 'form.user.fields.siren.value' | translate }}</strong> : {{ societyDistributor.distributor.identificationNumber }}
                </p>
                <p>
                    <strong>{{ 'form.user.fields.website.value' | translate }}</strong> : {{ societyDistributor.distributor.mainWebsite }}
                </p>
                <p>
                    <strong>{{ 'form.user.fields.address.value' | translate }}</strong> : {{ addressFields.address }}
                </p>
                <p>
                    <strong>{{ 'form.user.fields.zipcode.value' | translate }}</strong> : {{ addressFields.zipcode }}
                </p>
                <p>
                    <strong>{{ 'form.user.fields.city.value' | translate }}</strong> : {{ addressFields.city }}
                </p>
                <p>
                    <strong>{{ 'form.user.fields.country.value' | translate }}</strong> : {{ addressFields.country }}
                </p>
            </div>
        </div>
    </div>

</ng-template>

<!-- Accès aux offres et détails -->

<ng-template #accessOffersTemplate>

    <div class="row ligne_form">

        <ng-container [formGroup]="form">
            <!-- Accès aux offres -->

            <div class="form-group">
                <label>{{'society.distributors.hasAccessOffers.value' | translate}}</label>
                <div class="radio" >
                    <input type="radio" [value]="true" formControlName="hasAccessOffers" class="form-control" id="hasAccessOffersYes" >
                    <label for="hasAccessOffersYes">{{'form.user.fields.yes.value' | translate}}</label>
                </div>
                <div class="radio">
                    <input type="radio" [value]="false" formControlName="hasAccessOffers" class="form-control" id="hasAccessOffersNo" >
                    <label for="hasAccessOffersNo">{{'form.user.fields.no.value' | translate}}</label>
                </div>
                @if(form.get('hasAccessOffers').errors && (form.get('hasAccessOffers').dirty || form.get('hasAccessOffers').touched)) {
                    <mat-error>
                        <div class="invalid-feedback">
                            @if(form.get('hasAccessOffers').errors.required) {
                                <div>{{ 'form.control.error.required.value' | translate }}</div>
                            }
                        </div>
                    </mat-error>
                }
                @if(!form.get('hasAccessOffers').value) {
                    <span class="message-help">
                        <mat-icon class="tooltip_icon">info</mat-icon> {{ 'society.hasAccessOffers.deactivate.warning.value' | translate }}
                    </span>
                }
            </div>

        </ng-container>

    </div>

    <div class="row ligne_form">

        <div class="form-group">
            <div class="text_content">
                <p>
                    <strong>{{ 'distributor.marketplace.accepted.value' | translate }}</strong> : {{ societyDistributor.totalAcceptedMarketplaceOffers }}
                </p>
            </div>
            @for((offer of acceptedOffers$ | async); track offer) {
                <div class="text_content">
                    <p>
                        - <a [routerLink]="['/account/offer/read', offer.id]" [queryParams]="{ origin: 'societyDistributor', societyDistributor: societyDistributor.id }">{{ translationService.getFallbackTranslation(offer.translations).name }} {{ offer.reference ? ('(' + offer.reference + ')') : '' }}</a>
                    </p>
                </div>
            }
        </div>
    </div>

    <div class="row ligne_form">

        <div class="form-group">
            <div class="text_content">
                <p>
                    <strong>{{ 'distributor.marketplace.refused.value' | translate }}</strong> : {{ societyDistributor.totalRefusedMarketplaceOffers }}
                </p>
            </div>
            @for((offer of refusedOffers$ | async); track offer) {
                <div class="text_content">
                    <p>
                        - <a [routerLink]="['/account/offer/read', offer.id]" [queryParams]="{ origin: 'societyDistributor', societyDistributor: societyDistributor.id }">{{ translationService.getFallbackTranslation(offer.translations).name }} {{ offer.reference ? ('(' + offer.reference + ')') : '' }}</a>
                    </p>
                </div>
            }
        </div>
    </div>

</ng-template>

<ng-template #commissionTemplate>

    <div class="row marges ligne_form">
        <div class="col_12">
            <div class="text_content">
                <span [innerHTML]="'distributor.commission.description.travelAgency.title.value' | translate"></span>
            </div>
        </div>
    </div>

    <div class="row marges ligne_form">
        <div class="col_12">
            <div class="text_content">
                <span [innerHTML]="'distributor.commission.description.details.value' | translate: {commissionIndividualStay: commissionIndividualStay, commissionIndividualDay: commissionIndividualDay, commissionGroupStay: commissionGroupStay, commissionGroupDay: commissionGroupDay} | safeHtml"></span>
            </div>
        </div>
    </div>

    <div class="row marges ligne_form">
        <div class="col_12">
            <div class="text_content">
                <p>
                    <strong>{{ 'distributor.commission.incomingPayment.value' | translate }}</strong> : {{ ((incomingPayment ? 'yes' : 'no') + '.value') | translate }}
                </p>
            </div>
        </div>
    </div>

</ng-template>
